import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { FILTERS } from "components/Widget/filters";
import { getObjectPositiveValuesCount } from "utils/basic";
import FilterButton from "./FilterButton";
import classes from "./FilterClass.module.css";
import omit from "lodash/omit";
import Checkbox from "components/form/Checkbox";
import Typography from "components/Typography";
import { useWidgetContext } from "components/Widget/useWidgetContext";
import { getClasses } from "components/Widget/utils/utils";
import cn from "classnames";

const FilterClass = () => {
  const { filtersWatch, allCards, theme } = useWidgetContext();
  const { class: filterClass } = filtersWatch();

  const allClasses = useMemo(() => getClasses(allCards), [allCards]);

  return (
    <FilterButton
      popperClassName={classes.popper}
      className={classes.container}
      id={FILTERS.ids.class}
      getSelectedCount={getObjectPositiveValuesCount}
      renderForm={({ value, onChange }) => {
        return (
          <div>
            <Typography
              size="s"
              weight="bold"
              variant="subtitle"
              className={classes.title}
            >
              RV Class
            </Typography>

            <div
              className={cn(
                `row mt-m-8`,
                classes.row
              )}
            >
              {allClasses.map(i => (
                <div
                  key={i.id}
                  className={cn(
                    `col-6 mt-m-20`,
                    classes.col
                  )}
                >
                  <Checkbox
                    className={cn(
                      theme === 'dark' && classes.checkboxDark,
                    )}
                    labelTextClassName={classes.checkboxLabel}
                    pseudoCheckClassName={cn(
                      classes.checkboxPseudoCheck
                    )}
                    id={i.id}
                    name={i.id}
                    text={i.name}
                    checked={filterClass[i.id]?.checked || false}
                    onChange={(event) => {
                      const checked = event.target.checked;
                      onChange(omit(
                        { ...value, [i.id]: { checked: checked, name: i.name } },
                        !checked ? i.id : null
                      ));
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        );
      }}
    />
  );
};

FilterClass.propTypes = {
};

export default FilterClass;
